import script from "./TargetArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TargetArea.vue?vue&type=script&setup=true&lang=js"

import "./TargetArea.vue?vue&type=style&index=0&id=06e1c9be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e1c9be"]])

export default __exports__